import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap';
import Compressor from 'compressorjs';
import FormImagePrice from './FormImagePrice';
import { saveRideImage, createRide } from '../../actions/rideManagementActions';
import { getUserProfile } from '../../actions/userProfileActions';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { Editor, EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import 'draft-js/dist/Draft.css';
import FormAddress from './FormAddress';
import Captain from "../../assets/badges/captain.png";
import OwnerContract from "../Legal/OwnerContract";
import categoriesJSON from "../../assets/rides/rideCategories.json";
import AlertComponent from '../Alert/alert';

export default class RideForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rideInfo: { state: "online", details: {} },
            image: "",
            descState: EditorState.createEmpty(),
            address: "",
            categories: [],
            category: "",
            elemByCategory: categoriesJSON.categories,
            // elemByCategory: [{
            //     category: "Boat",
            //     types: [
            //         { value: "motorboat", show: "Bateaux à moteur" },
            //         { value: "fishingBoat", show: "Bateaux de pêche" },
            //         { value: "sailingBoat", show: "Bateaux à voile" },
            //         { value: "watercraft", show: "Moto-marines" },
            //         { value: "yatchs", show: "Yatchs" },
            //         { value: "other", show: "Autres bateaux" }
            //     ],
            //     fields: [
            //         { value: "make", show: "Fabriquant", type: "text" },
            //         { value: "model", show: "Modèle", type: "text" },
            //         { value: "motor", show: "Moteur", type: "text" },
            //         { value: "horsepower", show: "Puissance (HP)", type: "number" },
            //         { value: "fuelType", show: "Type Carburant", type: "text" },
            //         { value: "year", show: "Année", type: "number" },
            //         { value: "width", show: "Largeur (5'11)", type: "text" },
            //         { value: "length", show: "Longeur (5'11)", type: "text" },
            //         { value: "sleepCapacity", show: "Couchettes", type: "number" }
            //     ],
            //     booleans: [
            //         { value: "washrooms", show: "Toilettes" },
            //         { value: "trailer", show: "Faites-vous la livraison?" },
            //         { value: "captain", show: "Forfait Capitaine" }
            //     ]
            // }],
            disableType: true,
            types: [],
            type: "",
            fields: [],
            booleans: [],

            success: false,
            userInfo: {},
            loading: false,
            alert: {
                show: false,
                message: "",
                type: ""
            }
        }
        this.changeImage = this.changeImage.bind(this);
        this.onAddressChange = this.onAddressChange.bind(this);
        this.onDescChange = this.onDescChange.bind(this);
        this.renderDescription = this.renderDescription.bind(this);
        this.renderInputs = this.renderInputs.bind(this);
        this.onCategoryChange = this.onCategoryChange.bind(this);
        this.onRideInfoChange = this.onRideInfoChange.bind(this);
        this.onBoolChange = this.onBoolChange.bind(this);
        this.onTypeChange = this.onTypeChange.bind(this);
        this.renderBooleans = this.renderBooleans.bind(this);
        this.renderCategories = this.renderCategories.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.setCategories = this.setCategories.bind(this);
        this.handleDismiss = this.handleDismiss.bind(this);
    }

    componentDidMount() {
        this.setCategories();
        getUserProfile({ userId: this.props.user.userProfile.sub }, this.props.user.token).then((res) => {
            this.setState({
                userInfo: res.data
            })
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.ride && prevProps.ride !== this.props.ride) {
            this.onCategoryChange(this.props.ride.typeGroup).then(() => {
                this.setState({
                    rideInfo: this.props.ride,
                    descState: EditorState.createWithContent(convertFromRaw(JSON.parse(this.props.ride.description))),
                    address: this.props.ride.fullAddress,
                }, () => {
                    this.setState({
                        rideInfo: {
                            ...this.state.rideInfo,
                            image: this.state.rideInfo.images[0]
                        }
                    })
                })
            })
        }
    }

    setCategories() {
        let categories = [];
        categoriesJSON.categories.forEach((cat) => {
            categories.push(cat.category);
        })
        this.setState({
            categories
        })
    }

    // Modal
    handleCloseModal() {
        this.setState({ showModal: false });
    }

    handleDismiss() {
        this.setState({ alert: { ...this.state.alert, show: false } });
    }

    handleShowModal(e) {
        e.preventDefault();
        this.setState({ showModal: true });
    }

    onSubmit() {
        this.setState({
            showModal: false,
            loading: true,
            alert: { show: false, message: "", type: "" }
        }, () => {
            let { rideInfo, address } = this.state;
            const { user } = this.props;
            geocodeByAddress(address).then((geoAddress) => {
                let city = ""
                let province = ""
                let fullAddress = geoAddress[0].formatted_address
                geoAddress[0].address_components.forEach((elem) => {
                    if (elem.types[0] === "locality") {
                        city = elem.long_name
                    }
                    if (elem.types[0] === "administrative_area_level_1") {
                        province = elem.short_name
                    }
                })
                getLatLng(geoAddress[0]).then((res) => {
                    rideInfo = {
                        ...rideInfo,
                        fullAddress: fullAddress,
                        geoLocalLat: res.lat,
                        geoLocalLng: res.lng,
                        city: `${city}, ${province}`,
                        ownerId: user.userProfile.sub,
                        details: JSON.stringify(rideInfo.details)
                    }
                    createRide(rideInfo, user.token).then((result) => {
                        if (result.data && (result.data.succeed || result.data.objectId || result.data.code)) {
                            this.setState({
                                success: true,
                                loading: false
                            })
                        } else {
                            this.setState({
                                loading: false,
                                alert: {
                                    show: true,
                                    type: "danger",
                                    message: result.data && result.data.message ? result.data.message : "Une erreur est survenue lors de la création de la balade."
                                }
                            })
                        }
                    }).catch((err) => {
                        console.log("Erreur: ", err)
                        this.setState({
                            loading: false,
                            alert: {
                                show: true,
                                type: "danger",
                                message: "Erreur serveur: " + (err.message || err)
                            }
                        })
                    })
                }).catch(err => {
                    this.setState({
                        loading: false,
                        alert: {
                            show: true,
                            type: "danger",
                            message: "Erreur lors de la récupération des coordonnées GPS: " + (err.message || err)
                        }
                    })
                })
            }).catch(err => {
                this.setState({
                    loading: false,
                    alert: {
                        show: true,
                        type: "danger",
                        message: "Adresse invalide ou introuvable: " + (err.message || err)
                    }
                })
            })
        })
    }

    onCategoryChange(category) {
        return new Promise((res) => {
            if (category !== "Select a category") {
                let types = [];
                let fields = [];
                let booleans = [];
                this.state.elemByCategory.forEach((typeCat) => {
                    if (typeCat.category.value === category) {
                        types = typeCat.types;
                        fields = typeCat.fields;
                        booleans = typeCat.booleans;
                    }
                })
                this.setState({
                    category,
                    types,
                    fields,
                    booleans,
                    disableType: false,
                    rideInfo: {
                        ...this.state.rideInfo,
                        typeGroup: category,
                        type: "",
                        details: {}
                    }
                }, () => {
                    res();
                })
            }
            else {
                this.setState({
                    category,
                    types: [],
                    fields: [],
                    booleans: [],
                    disableType: true,
                    type: "",
                    rideInfo: {
                        ...this.state.rideInfo,
                        typeGroup: "",
                        type: "",
                        details: {}
                    }
                }, () => {
                    res();
                })
            }
        })
    }

    onTypeChange(data) {
        if (data === "Select a type") {
            this.onRideInfoChange("type", "", false)
        }
        else {
            this.onRideInfoChange("type", data, false)
        }
    }

    onRideInfoChange(key, data, isDetails) {
        if (isDetails) {
            this.setState({
                rideInfo: {
                    ...this.state.rideInfo,
                    details: {
                        ...this.state.rideInfo.details,
                        [key]: data
                    }
                }
            })
        }
        else {
            this.setState({
                rideInfo: {
                    ...this.state.rideInfo,
                    [key]: data
                }
            })
        }
    }

    onBoolChange(e, key, included) {
        e.preventDefault();
        this.onRideInfoChange(key, included, true);
    }

    onAddressChange(address) {
        this.setState({
            address
        })
    }

    changeImage(event) {
        event.preventDefault();
        let self = this;
        new Compressor(event.target.files[0], {
            quality: 0.2,
            success(result) {
                const form_data = new FormData()
                form_data.append('image', result)
                saveRideImage(form_data, self.props.user.token).then((res) => {
                    self.setState({
                        rideInfo: {
                            ...self.state.rideInfo,
                            image: res.data.imageUrl
                        }
                    })
                }).catch((err) => {
                    console.log(err);
                })
            }
        })
    }

    onDescChange(descState) {
        this.setState({
            descState,
        }, () => {
            this.setState({
                rideInfo: {
                    ...this.state.rideInfo,
                    description: JSON.stringify(convertToRaw(this.state.descState.getCurrentContent()))
                }
            })
        });
    }

    getIcon(key) {
        switch (key) {
            case "title": //"Title"
            case "model": //"Model"
            case "frameMaterial":
                return <i className="fas fa-info-circle"></i>
            case "subtitle": //"Sub-Title"
                return <i className="fas fa-tag"></i>
            case "description": //"Description"
                return <i className="fas fa-align-justify"></i>
            case "priceD": //"Price"
                return <i className="fas fa-dollar-sign"></i>
            case "address": //"Address"
                return <i className="fas fa-map-marker-alt"></i>
            case "make": //"Make"
                return <i className="fas fa-toolbox"></i>
            case "motor": //"Motor"
            case "engineDisplacement":
            case "transmission":
            case "driveType":
                return <i className="fas fa-cogs"></i>
            case "horsepower": //"Horsepower"
                return <i className="fas fa-horse"></i>
            case "fuelType": //"Fuel Type"
            case "fuelCapacity":
                return <i className="fas fa-gas-pump"></i>
            case "year": //"Year":
                return <i className="fas fa-calendar"></i>
            case "width": //"Width (5'11)"
            case "deckWidth":
                return <i className="fas fa-arrows-alt-h"></i>
            case "length": //"Length (5'11)"
            case "groundClearance":
            case "deckLength":
                return <i className="fas fa-arrows-alt-v"></i>
            case "sleepCapacity": //"Sleep Capacity"
                return <i className="fas fa-bed"></i>
            case "washrooms": //"Washroom"
                return <i className="fas fa-toilet"></i>
            case "trailer": //"Trailer Included"
                return <i className="fas fa-shipping-fast"></i>
            case "captain": //"Captain's Package"
                return <img src={Captain} className="addpage__captain" />
            case "dockType":
                return <i className="fas fa-anchor"></i>
            case "constructionType":
                return <i className="fas fa-hammer"></i>
            case "weight":
            case "dryWeight":
                return <i className="fas fa-weight"></i>
            case "maxPassenger":
                return <i className="fas fa-users"></i>
            case "maxWeight":
                return <i className="fas fa-weight-hanging"></i>
            case "nbPaddle":
                return <i className="fas fa-ship"></i>
            case "rvClass":
                return <i className="fas fa-bus"></i>
            case "kitchen":
                return <i className="fas fa-utensils"></i>
            case "frameSize":
            case "wheelSize":
                return <i className="fas fa-bicycle"></i>
            case "speeds":
                return <i className="fas fa-cog"></i>
            case "size":
                return <i className="fas fa-shoe-prints"></i>
            default:
                console.log("Nouvelle key: ", key);
                return "";
        }
    }

    renderBooleans(inputs) {
        if (!inputs) {
            return "";
        }
        let result = [];
        inputs.forEach((key) => {
            result.push(
                <div key={"details_" + key.value} className="ridepage__features__item">
                    {this.getIcon(key.value)}
                    <span className="ridepage__feature__item__title"> {key.showFr} </span>
                    <span className="ridepage__feature__item__detail">
                        <Button
                            variant={this.state.rideInfo.details[key.value] ? "outline-primary" : "primary"}
                            onClick={(e) => this.onBoolChange(e, key.value, false)}
                        >
                            Non Inclus
                        </Button>
                        <Button
                            variant={this.state.rideInfo.details[key.value] ? "primary" : "outline-primary"}
                            onClick={(e) => this.onBoolChange(e, key.value, true)}
                        >
                            Inclus
                        </Button>
                    </span>
                </div>
            );
        })
        return result
    }

    renderDescription() {
        return (
            <div className="ridepage__features__list">
                <div className="ridepage__features__item">
                    {this.getIcon("description")}
                    <span className="ridepage__feature__item__title"> Description </span>
                    <Editor editorState={this.state.descState}
                        onChange={this.onDescChange}
                        placeholder="Écrivez votre description"
                    />
                </div>
            </div>
        )
    }

    renderInputs(inputs, isDetails) {
        if (!inputs) {
            return "";
        }
        let result = [];
        inputs.forEach((key) => {
            result.push(
                <div key={"details_" + key.value} className="ridepage__features__item">
                    {this.getIcon(key.value)}
                    <span className="ridepage__feature__item__title"> {key.showFr} </span>
                    <span className="ridepage__feature__item__detail">
                        <Form.Control
                            name={key.value}
                            placeholder={key.showFr}
                            type={key.type}
                            value={isDetails ? this.state.rideInfo.details[key.value] : this.state.rideInfo[key.value]}
                            onChange={(e) => this.onRideInfoChange(key.value, e.target.value, isDetails)}
                            required
                        />
                    </span>
                </div>
            );
        })
        return result
    }

    renderCategories() {
        console.log("Categories: ", this.state.categories)
        console.log("Types: ", this.state.types)
        return (
            <div>
                <Row>
                    <Col>
                        <Form.Group as={Col} controlId="formGridState">
                            <Form.Label className="createride__category__title">Catégorie</Form.Label>
                            <Form.Control name="category" as="select" value={this.state.category} onChange={(e) => this.onCategoryChange(e.target.value)}>
                                <option>Choisir Catégorie</option>
                                {this.state.categories.map((category, i) => {
                                    return <option key={`category_${i}`} value={category.value}>{category.showFr}</option>
                                })}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group as={Col} controlId="formGridState">
                            <Form.Label className="createride__category__title">Type</Form.Label>
                            <Form.Control name="type" as="select"
                                onChange={(e) => this.onTypeChange(e.target.value)}
                                disabled={this.state.disableType}
                                value={this.state.rideInfo.type}
                            >
                                <option>Choisir Type</option>
                                {this.state.types.map((type, i) => {
                                    return <option key={`type_${i}`} value={type.value}>{type.showFr}</option>
                                })}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
            </div>
        )
    }

    render() {
        if (this.state.success) {
            return <Redirect to="/rider" />
        }
        if (this.state.categories.length === 0) {
            return <div></div>
        }
        const title = [
            { value: "title", showEn: "Title", showFr: "Titre", type: "text" },
            { value: "subtitle", showEn: "Subtitle", showFr: "Sous-Titre", type: "text" }
        ];
        const price = [{ value: "priceD", showEn: "Price / Day", showFr: "Prix / Jour", type: "number" }];
        const { fields, booleans } = this.state;

        return (
            <div className="createride__container">
                <AlertComponent type={this.state.alert.type} message={this.state.alert.message} show={this.state.alert.show} handleDismiss={this.handleDismiss} />
                {this.state.loading && (
                    <div className="text-center my-3">
                        <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                        <p>Traitement en cours...</p>
                    </div>
                )}
                <Form onSubmit={this.handleShowModal}>
                    {/* Top Section: Title/Subtitle, Image, Price/Save */}
                    <div className="ridepage__modern__grid">
                        {/* Left: Title and Subtitle */}
                        <div className="ridepage__modern__left">
                            <div className="ridepage__modern__titlegroup">
                                {this.renderInputs(title, false)}
                            </div>
                        </div>

                        {/* Center: Image Upload */}
                        <div className="ridepage__modern__center">
                            <div className="ridepage__image ridepage__image--modern">
                                <label htmlFor="rideImage" className="imgLabel">
                                    {this.state.rideInfo.image ? (
                                        <img src={this.state.rideInfo.image} alt="Ride Image" />
                                    ) : (
                                        <div className="ridepage__image__placeholder">
                                            <i className="fas fa-image"></i>
                                            <span>Cliquez pour ajouter une image</span>
                                        </div>
                                    )}
                                </label>
                                <input id="rideImage" type="file" accept='.jpg, .png, .jpeg' onChange={this.changeImage} hidden />
                            </div>
                        </div>

                        {/* Right: Price and Save Button */}
                        <div className="ridepage__modern__right">
                            <div className="ridepage__modern__sidebar">
                                <div className="ridepage__modern__pricegroup">
                                    {this.renderInputs(price, false)}
                                </div>
                                <Button type="submit" className="ridepage__modern__savebutton">
                                    Sauvegarder
                                </Button>
                            </div>
                        </div>
                    </div>

                    {/* Bottom Section: Description, Address, Specifications */}
                    <div className="ridepage__bottom__grid">
                        <div className="ridepage__info">
                            {this.renderDescription()}
                            <FormAddress address={this.state.address} getIcon={this.getIcon} onAddressChange={this.onAddressChange} />
                            <div className="ridepage__features">
                                <Form.Label className="createride__category__title">Spécifications</Form.Label>
                                {this.renderCategories()}
                                <div className="ridepage__features__list">
                                    {this.renderInputs(fields, true)}
                                </div>
                                <div className="ridepage__features__bools">
                                    {this.renderBooleans(booleans)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <OwnerContract
                        show={this.state.showModal}
                        onHide={this.handleClose}
                        user={this.state.userInfo}
                        onAccept={this.onSubmit}
                    />
                </Form>
            </div>
        )
    }
}